import { callFn } from "./api";

export interface LocatedBottle {
  id: string;
  name: string;
  distillery: string | null;
  locations: string[];
  matched_sizes: string[];
}
export interface BottleLookupResult {
  bottles: LocatedBottle[];
  has_more: boolean;
}
export type BottleSearchMode = "name" | "barcode";
export function findBottles(query: string, mode: BottleSearchMode = "name", offset = 0) {
  return callFn<BottleLookupResult>("bar-find-bottles", { query, mode, offset });
}
